module.exports = __webpack_public_path__ + "img/image_3.06965fda.png";